var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "homepage-container" },
    [
      _c(
        "section",
        { staticClass: "top-section", attrs: { id: _vm.sections.promoted.id } },
        [
          _vm.promotedProjects?.length
            ? _c("PromotedProjects", {
                attrs: { projects: _vm.promotedProjects, isOnTop: _vm.isStuck }
              })
            : _vm._e()
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "home-page-wrapper" },
        [
          _c(
            "div",
            {
              ref: "stickyHeader",
              class: [
                "story-line-container",
                "story-line",
                { stuck: _vm.isStuck },
                { "is-active": _vm.active }
              ],
              attrs: { id: "story-line-container" }
            },
            [_c("ShareStoryLine")],
            1
          ),
          _c("TopContributors", {
            attrs: {
              topContributors: _vm.topContributors,
              topProjects: _vm.topProjects,
              id: _vm.sections.contributors.id
            }
          }),
          _vm.mostActiveMarkets90?.length > 0 ||
          _vm.mediumActiveMarkets90?.length > 0
            ? _c("MapAndSubscriptions", {
                attrs: {
                  id: _vm.sections.activity.id,
                  mostActiveMarkets90: _vm.mostActiveMarkets90,
                  mediumActiveMarkets90: _vm.mediumActiveMarkets90,
                  mostActiveMarkets30: _vm.mostActiveMarkets30,
                  mediumActiveMarkets30: _vm.mediumActiveMarkets30,
                  isSubscribed30: _vm.isSubscribed30,
                  isSubscribed90: _vm.isSubscribed90,
                  isProcessing: _vm.isProcessing,
                  subscribers: _vm.subscribers
                },
                on: { subscribeClicked: _vm.subscribeClicked }
              })
            : _vm._e(),
          _c("HeroImage", { attrs: { id: _vm.sections.hero.id } })
        ],
        1
      ),
      _c("Footer"),
      _c("HelperButton", { attrs: { hasAssistance: false } })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }